/**
 * User: liliana
 * Date: 4/15/15
 * Time: 4:45 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

'use strict';

var SoaModel               = require('bunsen/models/SoaModel');

/**
 * @class Favorite
 * @extends SoaModel
 * @constructs Favorite object
 * @constructor
 */
var Favorite               = module.exports = SoaModel.extend();

var _                      = require('underscore');
var Backbone               = require('dibs-backbone');
var FavoriteParameters     = require('bunsen/collections/identity/FavoriteParameters');
var endpoints              = require('dibs-endpoints');
var User                   = require('bunsen/models/identity/User');

_.extend(Favorite.prototype, {
    relations : function () {
        return [
            {
                type             : Backbone.One,
                key              : 'user',
                relatedModel     : User
            },
            {
                type             : Backbone.Many,
                key              : 'parameters',
                collectionType   : FavoriteParameters
            },
            {
                type             : Backbone.One,
                key              : 'anchor',
                relatedModel     : Backbone.AssociatedModel.extend()
            }
        ];
    },

    defaults : function () {
        return {
            user         : {},
            page         : '',
            parameters   : []
        };
    },

    /**
     * @returns {string}
     */
    url : function () {
        return endpoints.favorite(this.get('id') || '');
    },

    /**
     * @returns {boolean}
     */
    isInactive : function () {
        return this.get('anchorStatus') === Favorite.ANCHOR_STATUS_INACTIVE;
    }

});

_.extend(Favorite, {

    /* TYPES */
    TYPE_SEARCH             : 'SEARCH',
    TYPE_DEALER             : 'SELLER',
    TYPE_DESIGNER           : 'DESIGNER',
    TYPE_USER_PREFERENCE    : 'USER_PREFERENCE',

    /* EMAIL PREFERENCE ENUMS */
    EMAIL_PREFERENCE_WEEKLY : 'WEEKLY',
    EMAIL_PREFERENCE_DAILY  : 'DAILY',
    EMAIL_PREFERENCE_NEVER  : 'NEVER',

    /* STATUS ENUMS */
    ANCHOR_STATUS_ACTIVE    : 'ACTIVE',
    ANCHOR_STATUS_INACTIVE  : 'INACTIVE'
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/Favorite.js
// module id = 367
// module chunks = 63